import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = window.location.hash.split("session_id=")[1];
    if (!sessionId) {
      navigate("/");
      return;
    }

    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        navigate("/binder", { state: { user: res.data } });
      })
      .catch(() => navigate("/"));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#05060f] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-white/20 border-t-[#A78BFA] rounded-full animate-spin" />
    </div>
  );
}
